import { useState } from "react";
import { PageHeader } from "@/components/rp";
import { ChatThread } from "@/components/ChatThread";
import { AiChat } from "@/components/AiChat";

const TABS = [
  { v: "staff", l: "RP Home" },
  { v: "ai", l: "Assistente AI" },
];

export default function ClientMessaggi() {
  const [tab, setTab] = useState("staff");
  return (
    <div className="max-w-3xl">
      <PageHeader label="Messaggi" title={tab === "staff" ? "Scrivi a RP Home" : "Assistente AI"} />
      <div className="inline-flex p-1 rounded-full bg-[#EBEBEB] mb-5" data-testid="messages-tabs">
        {TABS.map((t) => (
          <button key={t.v} onClick={() => setTab(t.v)} data-testid={`messages-tab-${t.v}`}
            className={`h-9 px-5 rounded-full text-sm font-medium transition-colors ${tab === t.v ? "bg-white text-black shadow-sm" : "text-[#757575]"}`}>
            {t.l}
          </button>
        ))}
      </div>
      {tab === "staff" ? <ChatThread myRole="client" /> : <AiChat />}
    </div>
  );
}
